export const GET_SIGNIN_EMAIL_REQUEST = "GET_SIGNIN_EMAIL_REQUEST";
export const GET_SIGNIN_EMAIL_ERROR = "GET_SIGNIN_EMAIL_ERROR";
export const GET_SIGNIN_EMAIL_SUCCESS = "GET_SIGNIN_EMAIL_SUCCESS";

export const FIREBASE_SIGNIN_PWD_REQUEST = "FIREBASE_SIGNIN_PWD_REQUEST";
export const FIREBASE_SIGNIN_PWD_ERROR = "FIREBASE_SIGNIN_PWD_ERROR";
export const FIREBASE_SIGNIN_PWD_SUCCESS = "FIREBASE_SIGNIN_PWD_SUCCESS";

export const GET_ALL_PRODUCTS_REQUEST = "GET_ALL_PRODUCTS_REQUEST";
export const GET_ALL_PRODUCTS_ERROR = "GET_ALL_PRODUCTS_ERROR";
export const GET_ALL_PRODUCTS_SUCCESS = "GET_ALL_PRODUCTS_SUCCESS";
